export default [{
  name: 'user/profile',
  path: '/user/profile',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/profile.vue')
}, {
  name: 'user/profile/v2',
  path: '/user/profile/v2',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/profile-v2.vue')
}, {
  name: 'user/security',
  path: '/user/security',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/security.vue')
}, {
  name: 'user/security/mobile',
  path: '/user/security/mobile',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/security-mobile.vue')
}, {
  name: 'user/security/pwd',
  path: '/user/security/pwd',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/security-pwd.vue')
}, {
  name: 'user/banks',
  path: '/user/banks',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/banks.vue')
}, {
  name: 'payment/auto',
  path: '/payment/auto',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/auto-payment.vue')
}, {
  name: 'payment/auto/open',
  path: '/payment/auto/open',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/auto-payment-open.vue')
}, {
  name: 'user/protocols',
  path: '/user/protocols',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/user/protocols.vue')
}]